import * as z from "zod";

const topProductItem = z.object({
  productId: z.string(),
  name: z.string(),
  sku: z.string(),
  imageUrl: z.string().nullable(),
  itemsSold30d: z.number(),
  totalRevenue30d: z.number(),
  onHand: z.number(),
  available: z.number(),
  daysOfCover: z.number().nullable(),
  inventoryValue: z.number(),
  incoming: z.number(),
  forecastedRevenue: z.number(),
});

export const getDashboard = {
  name: "getDashboard" as const,
  input: z.object({
    months: z.number().int().min(1).max(24).optional(),
    topProductsLimit: z.number().int().min(1).max(50).optional(),
  }),
  output: z.object({
    currency: z.string(),
    inventoryValue: z.object({ value: z.number() }),
    availableUnits: z.object({ units: z.number() }),
    incomingThisWeek: z.object({ units: z.number() }),
    skusAtRisk: z.object({ count: z.number() }),
    unitsSoldHistory: z.object({
      series: z.array(z.object({ date: z.date(), units: z.number() })),
    }),
    topProducts: z.object({ items: z.array(topProductItem) }),
  }),
};
